<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-9">
            <span translate="Settings.IntegrationsServicesSection.SBRNexus"></span>
        </h3>
    </div>
    <div class="p-4 pt-0">
        <label for="SBRNexusEnvironment" class="form-label" translate="Settings.IntegrationsServicesSection.SBRNexusEnvironment"><app-info-button labelName="Settings.IntegrationsServicesSection.SBRNexusEnvironmentTooltip"></app-info-button></label>
        <div ngbDropdown class="dropdown" ngDefaultControl id="SBRNexusEnvironment">
            <button class="btn dropdown-toggle form-control text-truncate default" type="button" id="dropdownMenu" ngbDropdownToggle>
                <span *ngIf="sbrNexus === 'BTBA'" translate="Settings.IntegrationsServicesSection.Acceptation"></span>
                <span *ngIf="sbrNexus === 'BTP'" translate="Settings.IntegrationsServicesSection.Production"></span>
                <em class="bi bi-chevron-down float-end ms-2" aria-hidden="true"></em>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                <button ngbDropdownItem value="BTBA" (click)="updateValue('BTBA')"><span translate="Settings.IntegrationsServicesSection.Acceptation"></span></button>
                <button ngbDropdownItem value="BTP" [disabled]="environment.platformname!=='Productie'" (click)="updateValue('BTP')"><span translate="Settings.IntegrationsServicesSection.Production"></span></button>
            </div>
        </div>

        <div class="col-12 mt-4 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="closeDialog()" translate>Button.Back</button></span>
            <span class="float-end"><button type="button" class="btn btn-sm btn-primary" (click)="save()" translate>Button.SaveChanges</button></span>
        </div>
    </div>    
</div>